<header class="bg-dc-gradient">
  <div class="flex items-center">
    <!-- Mobile: menu + mobile logo -->
    <div class="flex items-center lg:hidden">
      <img
        src="/icons/svg/menu-icon.svg"
        alt="Menu"
        (click)="menuClick.emit()"
      />
      <img
        [src]="'/images/logo-mobile.png'"
        class="px-5 cursor-pointer"
        alt="Mobile Logo"
        (click)="gotoDashboard()"
      />
    </div>

    <!-- Desktop/Tablet: main logo -->
    <img [src]="currentLogo" alt="Logo" class="hidden lg:block" />
  </div>

  <div class="hidden lg:flex flex-1 justify-center px-4">
    @if (selectedPrimaryMemberDisplay) {
    <p class="text-sm xl:text-base whitespace-nowrap overflow-hidden text-ellipsis max-w-[40rem]"
    [ngClass]="isPlatinumTheme ? 'text-[#1d2d4a]!' : 'text-white!'">
      <span class="font-semibold">{{ "APPLYING_FOR" | translate }}</span>
      <span class="font-light ms-1">{{ selectedPrimaryMemberDisplay }}</span>
    </p>
    }
  </div>

  <div class="flex items-center gap-6">
    @if (selectedLang == "ar") {
    <button type="button" (click)="switchLang('en', true)">English</button>
    }@else{
    <button type="button" (click)="switchLang('ar', true)">عربي</button>
    } @if (flags.directoryEnabled) {
    <button type="button" class="hidden lg:block" (click)="gotoDirectory()">
      {{ "HEADER.DIRECTORY" | translate }}
    </button>
    }
    

    <div class="relative text-left hidden lg:inline-block mt-1">
      <button
        type="button"
        id="menu-button"
        (click)="expansSupportMenu = !expansSupportMenu"
        class="flex gap-2"
      >
        <span>
          {{ "HEADER.SUPPORT" | translate }}
        </span>
        <img
          [src]="getIconPath('svg/chevron-down.svg')"
          class="transition-transform"
          [class.rotate-180]="expansSupportMenu"
        />
      </button>

      @if (expansSupportMenu) {
      <div
        class="absolute right-0 z-99 mt-4 w-70 origin-top-right bg-[#E5EBEF] shadow-lg ring-1 ring-black/5 focus:outline-hidden"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="menu-button"
        tabindex="-1"
      >
        <div role="none">
          <a
            routerLink="/service-manuals"
            (click)="expansSupportMenu = false"
            class="block px-4 py-2 text-base text-dc-navy font-semibold hover:bg-gray-200 border-b border-gray-300"
            >{{ "HEADER.RESOURCES" | translate }}</a
          >
        </div>
        <div role="none">
          <a
            routerLink="/faq"
            (click)="expansSupportMenu = false"
            class="block px-4 py-2 text-base text-dc-navy font-semibold hover:bg-gray-200"
            >{{ "HEADER.FAQ" | translate }}</a
          >
        </div>
      </div>
      }
    </div>
     <button type="button" class="hidden lg:block" (click)="gotoContactUs()">
      {{ "HEADER.CONTACT_US" | translate }}
    </button>

    <app-accessibility-menu
      [settings]="accessibilitySettings"
      [isSpeechSupported]="isSpeechSupported"
      [isReading]="isReading"
      [languageLabel]="languageLabel"
      (increaseFont)="increaseFont()"
      (decreaseFont)="decreaseFont()"
      (toggleHighContrast)="toggleHighContrast()"
      (toggleGrayscale)="toggleGrayscale()"
      (toggleUnderlineLinks)="toggleUnderlineLinks()"
      (toggleReadingGuide)="toggleReadingGuide()"
      (toggleBigCursor)="toggleBigCursor()"
      (increaseTextSpacing)="increaseTextSpacing()"
      (decreaseTextSpacing)="decreaseTextSpacing()"
      (increaseLineSpacing)="increaseLineSpacing()"
      (decreaseLineSpacing)="decreaseLineSpacing()"
      (toggleFontWeight)="toggleFontWeight()"
      (startReading)="startReadingSelection()"
      (stopReading)="stopReading()"
      (resetAccessibility)="resetAccessibility()"
      [isPlatinumTheme]="isPlatinumTheme"
    ></app-accessibility-menu>
    @if (flags.searchEnabled) {
    <button type="button" (click)="searchModal = !searchModal">
      <img [src]="getIconPath('svg/search.svg')" />
    </button>
    }
    <button type="button" (click)="gotoNotifications()" class="relative">
      <img [src]="getIconPath('svg/bell.svg')" />
      @if (unreadCount > 0) {
        <span
          class="absolute -right-2 -top-2 inline-flex min-h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-semibold leading-none text-white"
        >
          {{ unreadCount }}
        </span>
      }
    </button>
    <!-- <button type="button" (click)="gotoFaq()" class="hidden lg:block">
      <img [src]="getIconPath('svg/question.svg')" />
    </button> -->
    <!-- <button type="button" (click)="gotoSetting()" class="hidden lg:block">
      <img src="/icons/svg/setting.svg" />
    </button> -->
    @if(user?.username){
    <div
      (click)="gotoSetting()"
      class="user-avtar"
    >
      <a title="View profile">{{ user?.username?.at(0)?.toUpperCase() }}</a>
    </div>
    }
  </div>
</header>

@if (selectionReaderVisible) {
<div
  #selectionReaderPanel
  class="fixed z-50 bg-white px-2 py-1 shadow-2xl ring-1 ring-black/10"

  role="dialog"
  aria-live="polite"
  [style.top.px]="selectionReaderPosition.top"
  [style.left.px]="selectionReaderPosition.left"
>
  <!-- [style.top.px]="selectionReaderPosition.top"
  [style.left.px]="selectionReaderPosition.left"
  [style.width.px]="selectionReaderWidth"
  <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
    {{ selectionReaderStrings.heading }}
  </p> -->
  @if (!isSpeechSupported) {
  <p class="mt-2 text-xs text-red-600">
    {{ selectionReaderStrings.unsupported }}
  </p>
  }
  <div class="mt-1 flex flex-wrap gap-5">
    <button
      type="button"
      class=""
      (click)="onSelectionPlay()"
      [disabled]="!isSpeechSupported"
    >
      <img src="/icons/svg/speaker-high.svg" class="w-6" />
      <span>
        {{ (isPaused && readingSource === 'selection' ? selectionReaderStrings.resume : selectionReaderStrings.play) }}
      </span>
    </button>
    <!-- selection-reader-action selection-reader-action--secondary -->
   
    <button
      type="button"
      class=""
      (click)="onSelectionPause()"
      [disabled]="!isSpeechSupported || !(readingSource === 'selection' && isReading && !isPaused)"
    >
      <img src="/icons/svg/speaker-slash.svg" class="w-6"/>
      <span>{{ selectionReaderStrings.pause }}</span>
    </button>
    <button
      type="button"
      class=""
      (click)="onSelectionClose()"
    >
      <img src="/icons/svg/x-circle.svg" class="w-6"/>      
      <span>{{ selectionReaderStrings.close }}</span>
    </button>
  </div>
</div>
}

<!-- Open search modal -->
@if (searchModal) {
<div class="dc-modal">
  <div class="dc-modal-container w-lg!">
    <button class="modal-x-button" type="button" (click)="searchModal = false">
      <i class="fas fa-close"></i>
    </button>
    <h1 class="text-2xl font-semibold text-dc-navy">
      {{ "SEARCH" | translate }}
    </h1>
    <app-global-search [(isOpen)]="searchModal" (onBtnClick)="(false)" />
  </div>
</div>
}
